import React from "react";
import { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";
import  queryString from 'query-string';
import { useIntl } from "gatsby-plugin-intl"
// import * as api from '../modules/public'

/**
 * 解析 api url
 * @param baseURL
 * @param requestUrl
 * @returns
 */
export const urlResolve = (baseURL: string, requestUrl: string = "") => {
  if (requestUrl.startsWith("http")) {
    return requestUrl;
  }
  if (requestUrl.startsWith("/")) {
    return new URL(baseURL).origin + requestUrl;
  }
  return baseURL + requestUrl;
};
/**
 * 请求参数序列化
 * @param params
 * @returns
 */
export const paramsSerializer=(params:KeyValue):string=>{
  let newParams:KeyValue={}
  Object.keys(params).forEach(key=>{
    const value=params[key];
    if(value instanceof Date){
      newParams[key]=value.toISOString()
    }else if(typeof value==="object"){
      newParams[key]=JSON.stringify(value)
    }else{
      newParams[key]=value;
    }
  })
  return queryString.stringify(newParams);
}
/**
 * 响应来源于网关
 * @param response
 */
export const responseFromGateway=(response:AxiosResponse<KeyValue>):boolean=>{
  return response.headers["from"]==='gateway';
}

/**
 * 规范化响应数据(将 api 错误时的数据结构标准化)
 * @param data
 * @returns
 */
const gatewayResponseDataNormal = (response:AxiosResponse<any>,maybeError:boolean=true): AxiosResponse<KeyValue> => {
  const intl = useIntl();
  let data = response.data;
  if (typeof data === "string") {
    const code = response.status===200 ? -1 : response.status
    if (/^<!DOCTYPE HTML/i.test(data)) {
      data = { code, msg:'', __response_data: data }
    }else{
      data = { code, msg: data }
    }
  }
  data = data || {}
  if(maybeError){
    const code = data.code ?? data.status ?? response.status ?? -1;
    const msg = data.msg || data.error || data.message || intl.formatMessage({id:'服务端异常'});
    Object.assign(data,{code,msg})
  }else{
    const code:number = data.code ?? data.status ?? 0;
    const msg:string = data.msg || data.error || data.message || (code===0 ? "" : intl.formatMessage({id:'服务端业务异常'}));
    Object.assign(data,{code,msg})
  }
  response.data = data;
  return response;
};


/**
 * 请求成功处理（http 200）
 * @param response
 * @returns
 */
export const gatewayResponseHandler=(response:AxiosResponse<KeyValue>)=>{
  gatewayResponseDataNormal(response,false);
  const {code,msg} = response.data;
  if(code !== 0){ // 服务端业务异常，返回 Promise.reject 将错误抛出，统一在 responseErrorHandler 中处理
    const error:AxiosError = Object.assign(new Error(msg),{
      config:response.config,
      request:response.request,
      response,
    })
    return Promise.reject(error)
  }
  return response;
}
/**
 * 请求错误处理（http 非 200）
 * @param error
 * @returns
 */
export const gatewayResponseErrorHandler= async (error:AxiosError,axiosInstance:AxiosInstance)=>{
  if(!error.request){
    return Promise.reject(error);
  }
  if(!error.response){
    return Promise.reject(error);
  }
  const response = error.response
  gatewayResponseDataNormal(response,true);
  return Promise.reject(error);
}

